export default {
  title: 'Impressum',
  subtitle: 'Dostosuj dane widoczne w Impressum sklepu bez zmiany profilu firmy.',
  defaultsNotice:
    'Każde pole jest opcjonalne. Pozostaw je puste, aby korzystać z wartości profilu firmy — aktualny domyślny widoczny jest na szaro jako podgląd. Wypełnienie pola nadpisuje tylko Impressum; profil firmy pozostaje bez zmian.',
  fields: {
    legal_name: {
      label: 'Nazwa firmy / prawna',
      placeholder: 'np. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Imię właściciela',
      placeholder: 'np. Alex',
    },
    owner_last_name: {
      label: 'Nazwisko właściciela',
      placeholder: 'np. Müller',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'np. info@example.com',
      invalid: 'Wprowadź prawidłowy adres e-mail',
    },
    owner_phone_number: {
      label: 'Telefon',
      placeholder: 'np. +49 30 1234567',
    },
    tax_id: {
      label: 'NIP',
      placeholder: 'np. DE123456789',
    },
    address: {
      label: 'Adres',
      placeholder: 'Ulica, kod pocztowy, miasto',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    saved: 'Impressum zapisano',
    failed: 'Nie udało się zapisać Impressum',
  },
};
